import React, { useEffect, useState } from 'react'

const CustomerAddressPrintLayout = ({customer}) => {
  
  return (    
    <div style={{width:'10cm',height:'5cm',marginBottom:'3mm', marginRight:'2mm',   padding:'5mm'}} className='flex flex-col items-center text-bold text-sm bg-white text-black  rounded'>
       
        <div className='font-extrabold text-lg'>{customer.businessName},</div>
        <div>{customer.businessAddress},</div>
        <div>{customer.businessCity}, {customer.businessCountry}.</div>
        
         
        <p className='mt-3 w-full text-left flex justify-between'><span className='font-extrabold text-sm'>Contact :</span> {customer.businessContact}</p>
         
        
        <p className='w-full text-left flex justify-between'><span className='font-extrabold text-sm'>Email :</span>{customer.businessEmail}</p>
        
        
        <div className='w-full text-left flex justify-between'><span className='font-extrabold text-sm'>Fax No. :</span>{customer.faxNumber}</div>
        <div className='w-full text-left flex justify-between'><span className='font-extrabold text-sm'>Vat No. :</span>{customer.businessVatNumber}</div>
        
        
    </div>
  )
}

export default CustomerAddressPrintLayout